<template>
  <div style="text-align: center">
    <img
      src="@/assets/images/giphy.gif"
      width="60px"
    >
    <p class="mt-3">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
